module.exports = __webpack_public_path__ + "static/media/appstore.21585dac.svg";